export default __webpack_public_path__ + "static/media/ci4.1ed12e09.jpg";